enum AccessKeySortingColumns {
  Description = 'Description',
  Remark = 'Remark',
  BuildingUnits = 'BuildingUnits',
}

export default AccessKeySortingColumns;
